import type { Dealer } from '@makemydeal/dr-shared-types';

export const getCreditTiersByVehicleCondition = (dealer: Partial<Dealer>, condition: string) => {
    return dealer.creditTiersOptions && dealer.creditTiersOptions[condition];
};
